import { baseDepositEUR } from "@/lib/rent-discount";

/**
 * The deposit an applicant is shown and stored on their booking: the room's own
 * deposit when admin set one, otherwise 2x rent. Same chain as
 * resolve_expected_deposit_eur and create-application-account, so the website,
 * the stored `bookings.deposit_amount` and admin agree (COL-592).
 */
export function applicationDepositEUR(room: {
  price: number;
  baseDeposit: number | null;
}): number {
  return baseDepositEUR({
    monthly_rent: room.price,
    rooms: { price: room.price, deposit_amount: room.baseDeposit },
  });
}
